import { useOne, useShow } from '@refinedev/core';
import { Show } from '@refinedev/antd';
import { theme } from 'antd';
import type {
  PublicationListOut,
  SegmentErrorDetailOut,
} from '@/api/generated/schemas';
import { bareShowContentProps } from '@/components/common/show/shared';
import { useShowTab } from '@/components/common/show/useShowTab';
import { useRecordDocumentTitle } from '@/hooks/useRecordDocumentTitle';
import {
  SEGMENT_ERROR_DEFAULT_TAB,
  SEGMENT_ERROR_SHOW_TABS,
} from '../constants';
import { SegmentErrorShowHeader } from './SegmentErrorShowHeader';
import { SegmentErrorGeneralTab } from './SegmentErrorGeneralTab';

export const SegmentErrorShow = () => {
  const { token } = theme.useToken();
  const { query } = useShow<SegmentErrorDetailOut>({
    resource: 'progress.segment_errors',
  });
  const { data, isLoading } = query;
  const record = data?.data;

  const { result: publication } = useOne<PublicationListOut>({
    resource: 'user_catalog.publications',
    id: record?.publication_id ?? 0,
    queryOptions: { enabled: !!record?.publication_id },
  });

  // Rejected segments often arrive without a UUID, so the id carries the title.
  useRecordDocumentTitle(
    'progress.segment_errors',
    record && (record.segment_uuid ?? `#${record.id}`)
  );

  const [activeTab, onTabChange] = useShowTab(
    SEGMENT_ERROR_SHOW_TABS,
    SEGMENT_ERROR_DEFAULT_TAB
  );

  return (
    <Show isLoading={isLoading} contentProps={bareShowContentProps}>
      {record && (
        <>
          <SegmentErrorShowHeader
            record={record}
            activeTab={activeTab}
            onTabChange={onTabChange}
          />
          <div style={{ marginTop: token.margin }}>
            {activeTab === 'general' && (
              <SegmentErrorGeneralTab
                record={record}
                publication={publication}
              />
            )}
          </div>
        </>
      )}
    </Show>
  );
};
